/**
 * Natura Karma — Teslimat alanı etiketleri
 *
 * Yalnızca Natura Karma özelleştirilmiş ana ürününün line item
 * property adlarını ve teslimat tarihi gösterimini değiştirir.
 *
 * Başka sepet/checkout davranışına, fiyata veya ürün sırasına dokunmaz.
 */
(function () {
  'use strict';

  if (window.__TF_CHECKOUT_LABELS_INSTALLED__) return;
  window.__TF_CHECKOUT_LABELS_INSTALLED__ = true;

  var originalFetch = window.fetch.bind(window);

  var labelMap = {
    'Teslimat Tarihi': 'Teslimat Günü',
    'Teslimat Aralığı': 'Teslimat Saati',
    'Gönderim Bölgesi': 'Alıcı İlçe',
    'Gönderim Adresi': 'Alıcı Adres',
    'Gönderen İsmi': 'Gönderen'
  };

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddRequest(input) {
    return /\/cart\/add(?:\.js)?(?:\?|$)/i.test(getUrl(input));
  }

  function formatDateValue(value) {
    if (value === null || typeof value === 'undefined') return value;

    var text = String(value);

    // Örnek: Bugün (2026-07-14) -> Bugün (14.07.2026)
    text = text.replace(
      /\((\d{4})-(\d{2})-(\d{2})\)/g,
      function (_, year, month, day) {
        return '(' + day + '.' + month + '.' + year + ')';
      }
    );

    // Değer yalnızca ISO tarih ise: 2026-07-14 -> 14.07.2026
    text = text.replace(
      /^(\d{4})-(\d{2})-(\d{2})$/,
      function (_, year, month, day) {
        return day + '.' + month + '.' + year;
      }
    );

    return text;
  }

  function transformMainProperties(properties) {
    var transformed = {};

    Object.keys(properties || {}).forEach(function (key) {
      var nextKey = labelMap[key] || key;
      var value = properties[key];

      if (key === 'Teslimat Tarihi' || nextKey === 'Teslimat Günü') {
        value = formatDateValue(value);
      }

      transformed[nextKey] = value;
    });

    return transformed;
  }

  function transformPayload(payload) {
    if (!payload || !Array.isArray(payload.items)) return payload;

    var changed = false;

    var items = payload.items.map(function (item) {
      var properties =
        item && item.properties && typeof item.properties === 'object'
          ? item.properties
          : null;

      if (
        !properties ||
        String(properties['_TF Ana Ürün'] || '').toLowerCase() !== 'true'
      ) {
        return item;
      }

      changed = true;

      return Object.assign({}, item, {
        properties: transformMainProperties(properties)
      });
    });

    if (!changed) return payload;

    return Object.assign({}, payload, {
      items: items
    });
  }

  window.fetch = function (input, init) {
    if (
      !isCartAddRequest(input) ||
      !init ||
      typeof init.body !== 'string'
    ) {
      return originalFetch(input, init);
    }

    try {
      var payload = JSON.parse(init.body);
      var transformedPayload = transformPayload(payload);

      if (transformedPayload === payload) {
        return originalFetch(input, init);
      }

      var nextInit = Object.assign({}, init, {
        body: JSON.stringify(transformedPayload)
      });

      return originalFetch(input, nextInit);
    } catch (error) {
      console.warn('TF teslimat etiketleri uygulanamadı:', error);
      return originalFetch(input, init);
    }
  };
})();
